import { Chart } from "chart.js";
import { ChoroplethController, GeoFeature, ColorScale, ProjectionScale } from "chartjs-chart-geo";

Chart.defaults.font.family =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", SymbolaRegular';
Chart.defaults.plugins.title.font.weight = 600;
Chart.defaults.plugins.subtitle.font.weight = 600;

Chart.register(ChoroplethController, GeoFeature, ColorScale, ProjectionScale);
